const BASE_URL = import.meta.env.VITE_APP_BACKEND_API_URL;

const DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

let refreshInFlight = null;

async function refreshSession() {
  if (!refreshInFlight) {
    refreshInFlight = fetch(`${BASE_URL}/api/refresh`, {
      method: "POST",
      credentials: "include",
      headers: DEFAULT_HEADERS,
    })
      .then((res) => res.ok)
      .catch(() => false)
      .finally(() => {
        refreshInFlight = null;
      });
  }

  return refreshInFlight;
}

async function parseErrorResponse(res) {
  try {
    const data = await res.clone().json();
    return typeof data?.message === "string" ? data.message : null;
  } catch {
    return null;
  }
}

async function request(path, options = {}) {
  const {
    method = "GET",
    body,
    headers,
    signal,
    _retryAfterRefresh = true,
  } = options;

  const url = path.startsWith("http") ? path : `${BASE_URL}${path}`;

  const fetchOptions = {
    method,
    credentials: "include",
    headers: {
      ...DEFAULT_HEADERS,
      ...(headers || {}),
    },
    signal,
  };

  if (body !== undefined) {
    fetchOptions.body = typeof body === "string" ? body : JSON.stringify(body);
  }

  let res = await fetch(url, fetchOptions);

  if (res.status === 401 && _retryAfterRefresh) {
    await refreshSession();
    // Always retry once after attempting refresh.
    res = await fetch(url, { ...fetchOptions });
  }

  if (!res.ok) {
    const serverMessage = await parseErrorResponse(res);
    const error = new Error(serverMessage || "");
    error.status = res.status;
    error.serverMessage = serverMessage;
    throw error;
  }

  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return res.json();
  }

  // Support empty responses (e.g., logout), or text.
  return res.text();
}

export const apiClient = {
  request,
  refreshSession,
  saveScene: (data) =>
    request("/api/save_scene", { method: "POST", body: data }),
  getScene: () => request("/api/get_scene", { method: "GET" }),
};
